import isUaWebview from "is-ua-webview";

export const isWebview = (userAgentArgs?: string) => {
  if (!userAgentArgs || typeof window === 'undefined') {
    return false;
  }
  
  return isUaWebview(userAgentArgs || navigator.userAgent);
}
